import { useTranslation } from 'react-i18next';
import { useMatch, useNavigate } from 'react-router-dom-v5-compat';
import { Routes } from 'app/routes/routes';
import { Button, ButtonEdge, ButtonVariant } from 'app/components/core/Button';
import * as styles from './DeploymentOverviewButton.css';

export function DeploymentOverviewButton({ onClick }) {
    const { t } = useTranslation();
    const match = useMatch(Routes.DEPLOYMENT_OVERVIEW);
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(match ? -1 : Routes.DEPLOYMENT_OVERVIEW);
        onClick();
    };

    return (
        <Button
            className={styles.button}
            onClick={handleClick}
            icon="deployment"
            edge={ButtonEdge.FLAT}
            variant={ButtonVariant.GHOST}
            label={t('deploymentOverview:button.title')}
            fullWidth
            testId="deployment-overview-button">
            {t('deploymentOverview:button.label')}
        </Button>
    );
}
